import { render, staticRenderFns } from "./CustomCollapseItem.vue?vue&type=template&id=ea61d72c&scoped=true"
import script from "./CustomCollapseItem.vue?vue&type=script&lang=js"
export * from "./CustomCollapseItem.vue?vue&type=script&lang=js"
import style0 from "./CustomCollapseItem.vue?vue&type=style&index=0&id=ea61d72c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea61d72c",
  null
  
)

export default component.exports